/**
 * The Toronto Zoo Plus card artwork.
 *
 * Its own module rather than an export from the card, because the habitat preview's `tzplus`
 * variant shows the same picture on its cover card and `routes/habitatPreview/variants.ts` is a
 * pure config module — importing a React component there to name an image would drag component
 * code into every chunk that reads the variant table.
 *
 * The intrinsic size travels with it so consumers can reserve the space before the image loads,
 * which is what stops the card reflowing mid-render. The artwork carries its own text — the Toronto
 * Zoo mark and the "extended experience" line, which used to be DOM and now are pixels — so it is
 * never decorative, and every consumer must render the alt text below rather than an empty string.
 */
const TZ_PLUS_IMAGE = {
  src: 'https://zoolife.tv/assets/products/tz-plus-week-pass.webp',
  width: 672,
  height: 208,
  alt: 'Toronto Zoo Plus — get the extended experience for your visit',
} as const;

export default TZ_PLUS_IMAGE;
